import { makeStyles } from "@material-ui/styles";

const gameStatsContainerStyles = makeStyles((theme) => ({
	contentContainer: {
		maxHeight: "100%",
		overflow: "auto"
	},
	gridContainer: { "@media print": { display: "block" } },
	gridItem: {
		"@media print": {
			pageBreakInside: "avoid"
		}
	},
	orderOfFinish: {
		color: "#5B5B5B",
		paddingBottom: 10
	},
	buttonBox: {
		gap: theme.spacing(1)
	}
}));

export default gameStatsContainerStyles;
